import { render, staticRenderFns } from "./ExamAsCollFromRegForm.vue?vue&type=template&id=3d0e4856&scoped=true&"
import script from "./ExamAsCollFromRegForm.vue?vue&type=script&lang=js&"
export * from "./ExamAsCollFromRegForm.vue?vue&type=script&lang=js&"
import style0 from "./ExamAsCollFromRegForm.vue?vue&type=style&index=0&id=3d0e4856&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0e4856",
  null
  
)

export default component.exports